package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("swift_ui_basic_properties")
@Composable
fun BasicPropertiesSwiftUIPage() {
    BlogLayout(
        PageProperties(
            "SwiftUI",
            ""),
        BlogProperties("SwiftUI", "Property Wrappers")
    ) {
        Column(horizontalAlignment = Alignment.Start)
        {
            SpanText(
                text = "@State",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "@State is used to store and manage data that changes within a single view. It helps keep your user interface updated when the data changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "@Binding",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "@Binding creates a two - way connection between a parent view and a child view, so changes in the child view affect the parent view and vice versa.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "@Published",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "@Published is used within ObservableObject classes to automatically notify views of changes to specific properties.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "@ObservedObject",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "@ObservedObject allows a view to watch an external object for changes. When the object updates, the view will automatically refresh.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "@StateObject (Creating and Managing Observable Data)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "@stateObject is used to create and own an ObservableObject within a view. It ensures that the object is properly managed and kept alive for the view's lifecycle.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "@EnvironmentObject",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "@EnvironmentObject provides a way to inject data into the environment so that many views can access it without passing it explicitly.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "@Environment",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Environment allows your view to access and adapt to system - wide settings like the color scheme or locale.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "@AppStorage",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "@AppStorage simplifies storing and retrieving small pieces of data in UserDefaults, so they persist between app launches,",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    import Foundation
                    import SwiftData

                    @Observable
                    class SearchFilter {
                        var name = ""
                        var includeDateFilter = false
                        var joinDate = Date()
                        var sortOrder: [SortDescriptor<User>] = []
                    }
                    """.trimIndent()
            )

            //
            KotlinCode(
                code = """
                    import Foundation
                    import SwiftUI

                    class NetworkUtils {
                        static let shared = NetworkUtils()
                        
                        func makeAPIRequest(
                            url: URL,
                            httpMethod: HttpMethod,
                            postData: Any? = nil, // can be a Model or JSON request
                            isSecureRequest: Bool = true
                        ) async -> (Data?, URLResponse?) {
                            
                            var attemptsRetried = 0
                            
                            while true {
                                do {
                                    var request = URLRequest(url: url)
                                    request.httpMethod = httpMethod.getMethod
                                    request.cachePolicy = .reloadIgnoringLocalCacheData
                                    request.timeoutInterval = Constants.timeoutInterval
                                    request.setValue("application/json", forHTTPHeaderField: "Content-Type")
                                    
                                    let accessToken = Constants.accessToken
                                    let deviceID = Constants.deviceId
                                    
                                    if isSecureRequest {
                                        request.addValue("Bearer \(accessToken)", forHTTPHeaderField: "Authorization")
                                    }
                                    request.addValue(deviceID, forHTTPHeaderField: "device_id")
                                    
                                    /*
                                    if httpMethod == .POST || httpMethod == .PUT || httpMethod == .PATCH {
                                        if let postData = postData {
                                            let jsonData = try JSONEncoder().encode(postData)
                                            request.httpBody = jsonData
                                        } else {
                                            request.httpBody = Data()
                                        }
                                    }
                                    */
                                    
                                    if let postData = postData {
                                        if let dictData = postData as? [String: Any] { //MARK: JSON DATA. So serialize dictionary to JSON data
                                            let jsonData = try JSONSerialization.data(withJSONObject: dictData, options: [])
                                            request.httpBody = jsonData
                                        }
                                        else if let codableData = postData as? Encodable { //MARK: MODEL DATA. So encode Codable model
                                            // Try
                                            let jsonData = try JSONEncoder().encode(AnyEncodable(codableData))
                                            request.httpBody = jsonData
                                        }
                                        else {
                                            print("DEBUG: Unsupported postData type")
                                            request.httpBody = Data()
                                        }
                                    }
                                    
                                    if let body = request.httpBody, let bodyString = String(data: body, encoding: .utf8) {
                                        print("DEBUG: Request Body: \(bodyString)")
                                    }
                                    
                                    let (data, response) = try await URLSession.shared.data(for: request)
                                    
                                    if let responseString = String(data: data, encoding: .utf8) {
                                        print("DEBUG: ************************************************************************************************")
                                        print("DEBUG: URL: \(url)")
                                        print("DEBUG: ************************************************************************************************")
                                        print("DEBUG: Raw Response: \(responseString)")
                                        print("DEBUG: ************************************************************************************************")
                                    } else {
                                        print("DEBUG: ************************************************************************************************")
                                        print("DEBUG: URL: \(url)")
                                        print("DEBUG: ************************************************************************************************")
                                        print("DEBUG: Raw Response: \(data)")
                                        print("DEBUG: ************************************************************************************************")
                                    }
                                    
                                    return (data, response)
                                    
                                } catch {
                                    let errorMessage = error.localizedDescription.lowercased()
                                    
                                    if errorMessage.contains("network connection was lost") {
                                        // Handle network lost if needed
                                        // NetworkMonitor.shared.isConnected = false
                                    }
                                    
                                    if errorMessage.contains("the request timed out"), attemptsRetried < 2 {
                                        attemptsRetried += 1
                                        print("DEBUG: Retrying request due to timeout, attempt \(attemptsRetried)")
                                        continue // retry the request
                                    }
                                    
                                    print("DEBUG: API ERROR occurred. Error is \(error.localizedDescription)")
                                    return (nil, nil)
                                }
                            }
                        }
                    }


                    enum HttpMethod: String {
                        case POST
                        case GET
                        case PUT
                        case DELETE
                        case PATCH
                        
                        var getMethod: String {
                            switch self {
                            case .POST:
                                return "POST"
                            case .GET:
                                return "GET"
                            case .PUT:
                                return "PUT"
                            case .DELETE:
                                return "DELETE"
                            case .PATCH:
                                return "PATCH"
                            }
                        }
                    }
                    
                    enum APIError: Error, CustomStringConvertible{
                        case badURL
                        case urlSession(Error)
                        case badResponse(Int)
                        case decoding(DecodingError)
                        case custom(String)
                        case smthWentWrong
                        case unkown
                        case unexpected
                        
                        var description: String {
                            switch self {
                            case .badURL:
                                return "Bad URL"
                            case .urlSession(let error):
                                return "\(error.localizedDescription)"
                            case .badResponse(let statusCode):
                                return "Unexpected error occurred, please try again."
                            case .decoding(let decodingError):
                                return "Unexpected error occurred, please try again."
                            case .custom(let error):
                                return error
                            case .smthWentWrong:
                                return "Oops! Something went wrong, please try again."
                            case .unkown:
                                return "Unknown error, please try again."
                            case .unexpected:
                                return "Unexpected error occurred, kindly try again."
                            }
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}















